import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  useMediaQuery,
  Grid,
  Tooltip
} from "@mui/material";
import { BiSolidEdit } from "react-icons/bi";
import { MdOutlineDelete } from "react-icons/md";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { get_fillers, add_filler, edit_filler, delete_filler, get_profile_data } from "../Api service/APIvariables";
import SnackBar from "./SnackBar";
import CustomPagination from "./CustomPagination";

const sysName = localStorage.getItem("user_name") || "Your Profile Name";
const sysEmail = localStorage.getItem("user_email") || "Your Profile Email";
const sysMobile = localStorage.getItem("user_mobile") || "Your Profile Mobile";
const sysCompany = localStorage.getItem("company_name") || "Your Profile Company";

const initialSystemFillers = [
  { id: "sys_1", filler_key: "MyName", filler_value: sysName, isSystem: true, generatedId: 1 },
  { id: "sys_2", filler_key: "MyEmail", filler_value: sysEmail, isSystem: true, generatedId: 2 },
  { id: "sys_3", filler_key: "MyMobile", filler_value: sysMobile, isSystem: true, generatedId: 3 },
  { id: "sys_4", filler_key: "MyCompany", filler_value: sysCompany, isSystem: true, generatedId: 4 },
  { id: "sys_5", filler_key: "CompanyUserName", filler_value: "Dynamic Card Contact Name", isSystem: true, generatedId: 5 },
  { id: "sys_6", filler_key: "CompanyEmail", filler_value: "Dynamic Card Email", isSystem: true, generatedId: 6 },
  { id: "sys_7", filler_key: "CompanyName", filler_value: "Dynamic Card Company", isSystem: true, generatedId: 7 },
  { id: "sys_8", filler_key: "CompanyWebsite", filler_value: "Dynamic Card Website", isSystem: true, generatedId: 8 },
  { id: "sys_9", filler_key: "CurrentDate", filler_value: "Dynamic System Date", isSystem: true, generatedId: 9 },
  { id: "sys_10", filler_key: "CurrentTime", filler_value: "Dynamic System Time", isSystem: true, generatedId: 10 },
  { id: "sys_11", filler_key: "CurrentDateTime", filler_value: "Dynamic System Date & Time", isSystem: true, generatedId: 11 },
];

const Fillers = () => {
  const [fillers, setFillers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentFiller, setCurrentFiller] = useState({ id: "", filler_key: "", filler_value: "", is_system: 0, plan_required: 1 });
  const [loading, setLoading] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [fillerToDelete, setFillerToDelete] = useState(null);
  
  const isAdmin = window.location.pathname.startsWith("/admin");
  
  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // SnackBar
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false);
  const [message, setMessage] = useState("");

  const isMobile = useMediaQuery("(max-width:768px)");
  const user_id = localStorage.getItem("user_id");
  const token = localStorage.getItem("auth_token");

  useEffect(() => {
    fetchFillers();
  }, []);

  const fetchFillers = async () => {
    try {
      const formData = new FormData();
      formData.append("user_id", user_id);

      // Fetch Profile Data (Optional to dynamically replace user's own data in UI)
      let sysName = "Your Profile Name";
      let sysEmail = "Your Profile Email";
      let sysMobile = "Your Profile Mobile";
      let sysCompany = "Your Profile Company";

      try {
        const profileRes = await fetch(get_profile_data, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
        const profileResult = await profileRes.json();
        if (!profileResult.error && profileResult.data) {
          sysName = profileResult.data.name || sysName;
          sysEmail = profileResult.data.email || sysEmail;
          sysMobile = profileResult.data.mobile || sysMobile;
          sysCompany = profileResult.data.company_name || sysCompany;
        }
      } catch (err) {
        console.error("Failed to fetch profile data for fillers", err);
      }

      // Fetch All Fillers
      const response = await fetch(get_fillers, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();
      
      if (!result.error && result.data) {
        const mappedFillers = result.data.map((row, index) => {
          let value = row.filler_value;
          if (row.is_system == 1) {
             if (row.filler_key === 'MyName') value = sysName;
             if (row.filler_key === 'MyEmail') value = sysEmail;
             if (row.filler_key === 'MyMobile') value = sysMobile;
             if (row.filler_key === 'MyCompany') value = sysCompany;
          }
          return {
            ...row,
            filler_value: value,
            isSystem: row.is_system == 1,
            generatedId: index + 1
          };
        });
        setFillers(mappedFillers);
      } else {
        setFillers([]);
      }
    } catch (error) {
      console.error("Error fetching fillers:", error);
      setFillers([]);
    }
  };

  const handleOpenAdd = () => {
    setCurrentFiller({ id: "", filler_key: "", filler_value: "", is_system: 0, plan_required: 1 });
    setIsEditing(false);
    setOpenDialog(true);
  };

  const handleOpenEdit = (filler) => {
    setCurrentFiller({ id: filler.id, filler_key: filler.filler_key, filler_value: filler.filler_value, is_system: filler.is_system, plan_required: filler.plan_required });
    setIsEditing(true);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentFiller({ id: "", filler_key: "", filler_value: "", is_system: 0, plan_required: 1 });
  };

  const handleSaveFiller = async () => {
    if (!currentFiller.filler_key || !currentFiller.filler_value) {
      setOpen(true);
      setStatus(false);
      setColor(false);
      setMessage("Key and Value are required.");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("filler_key", currentFiller.filler_key);
      formData.append("filler_value", currentFiller.filler_value);
      formData.append("plan_required", currentFiller.plan_required || 1);
      
      const endpoint = isEditing ? edit_filler : add_filler;
      if (isEditing) {
        formData.append("filler_id", currentFiller.id);
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();
      setOpen(true);
      setStatus(!result.error);
      setColor(!result.error);
      setMessage(result.message);

      if (!result.error) {
        handleCloseDialog();
        fetchFillers();
      }
    } catch (error) {
      setOpen(true);
      setStatus(false);
      setColor(false);
      setMessage("Error saving filler.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setFillerToDelete(id);
    setConfirmDeleteOpen(true);
  };

  const proceedDelete = async () => {
    try {
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("filler_id", fillerToDelete);

      const response = await fetch(delete_filler, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();
      setOpen(true);
      setStatus(!result.error);
      setColor(!result.error);
      setMessage(result.message);

      if (!result.error) {
        setConfirmDeleteOpen(false);
        fetchFillers();
      }
    } catch (error) {
      setOpen(true);
      setStatus(false);
      setColor(false);
      setMessage("Error deleting filler.");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedFillers = fillers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ padding: isMobile ? "0px" : "15px", paddingTop: isMobile ? "10px" : "10px", width: "100%" }}>
      <SnackBar open={open} message={message} status={status} color={color} setOpen={setOpen} />
      
      <Grid container spacing={2} sx={{ marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Grid item xs={12} sm={4} md={3} sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>Template Fillers</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", justifyContent: isMobile ? "flex-start" : "flex-end" }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            sx={{ fontWeight: "bold", textTransform: "none", fontSize: "16px", borderRadius: "8px" }}
            onClick={handleOpenAdd}
          >
            Add Filler
          </Button>
        </Grid>
      </Grid>

      {/* Removed the predefined system placeholders box as requested */}

      <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "12px", border: "1px solid #ddd" }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "#6b7280" }}>No.</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#6b7280" }}>Key Placeholder</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#6b7280" }}>Value</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#6b7280" }}>Plan Required</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#6b7280" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedFillers.length > 0 ? (
              paginatedFillers.map((filler) => (
                <TableRow key={filler.id} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell>{filler.generatedId}</TableCell>
                  <TableCell>
                    <Box sx={{ backgroundColor: "#eef2ff", padding: "4px 8px", borderRadius: "4px", display: "inline-block", color: "#4f46e5", fontWeight: "bold" }}>
                      {"{{" + filler.filler_key + "}}"}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: filler.isSystem ? "#9e9e9e" : "inherit", fontStyle: filler.isSystem ? "italic" : "normal" }}>
                    {filler.filler_value}
                  </TableCell>
                  <TableCell>
                    {filler.isSystem ? (filler.plan_required == 1 ? "Free" : filler.plan_required == 2 ? "Plus" : filler.plan_required == 3 ? "Pro" : "Unlimited") : "-"}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {(!filler.isSystem || isAdmin) && (
                        <Tooltip title="Edit">
                          <IconButton onClick={() => handleOpenEdit(filler)} sx={{ color: "#3b82f6" }}>
                            <BiSolidEdit />
                          </IconButton>
                        </Tooltip>
                      )}
                      {!filler.isSystem && (
                        <Tooltip title="Delete">
                          <IconButton onClick={() => handleDelete(filler.id)} sx={{ color: "#ef4444" }}>
                            <MdOutlineDelete />
                          </IconButton>
                        </Tooltip>
                      )}
                      {filler.isSystem && (
                        <Typography variant="caption" sx={{ color: "#9e9e9e", fontWeight: "bold", alignSelf: "center", ml: isAdmin ? 1 : 0 }}>
                          SYSTEM
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                  No custom fillers found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        style={{
          display: "flex",
          width: isMobile ? "100%" : "40%",
          justifyContent: "flex-end",
          alignItems: "center",
          marginLeft: "auto",
        }}
      >
        <CustomPagination
          count={fillers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: { xs: "10px", sm: "14px", md: "14px" },
            width: "auto",
            justifyContent: "space-between",
            marginBottom: 2,
          }}
        />
      </div>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: "bold" }}>
          {isEditing ? "Edit Filler" : "Add Custom Filler"}
          <IconButton onClick={handleCloseDialog}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Define a custom placeholder key and the value it should replace in your templates. Do not include spaces in the key.
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Placeholder Key (e.g. JobTitle)"
            type="text"
            fullWidth
            variant="outlined"
            value={currentFiller.filler_key}
            onChange={(e) => setCurrentFiller({ ...currentFiller, filler_key: e.target.value.replace(/\s/g, '') })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Value to Insert"
            type="text"
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            value={currentFiller.filler_value}
            onChange={(e) => setCurrentFiller({ ...currentFiller, filler_value: e.target.value })}
            disabled={currentFiller.is_system == 1} // Do not allow editing value of system fillers
            sx={{ mb: 2 }}
          />
          {isAdmin && currentFiller.is_system == 1 && (
            <Box mb={2}>
              <label style={{ marginBottom: 3, fontWeight: 600, display: 'block' }}>Plan Access Required</label>
              <select
                name="plan_required"
                value={currentFiller.plan_required || 1}
                onChange={(e) => setCurrentFiller((prev) => ({ ...prev, plan_required: e.target.value }))}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #c4c4c4",
                }}
              >
                <option value={1}>Free</option>
                <option value={2}>Plus</option>
                <option value={3}>Pro</option>
                <option value={4}>Unlimited</option>
              </select>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseDialog} color="inherit" variant="outlined">Cancel</Button>
          <Button onClick={handleSaveFiller} color="primary" variant="contained" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Delete Modal */}
      <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color: '#d32f2f', fontWeight: 'bold' }}>Delete Filler</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">
            Are you sure you want to delete this filler? 
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteOpen(false)}>Cancel</Button>
          <Button onClick={proceedDelete} variant="contained" color="error">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Fillers;
